import { createAction, props } from '@ngrx/store';
import { CityModel } from 'src/app/models/city.model';

export const LOCATION_FEATURE = 'location';
export const LOAD_CITIES = '[Location] Load Cities';
export const LOAD_CITIES_SUCCESS = '[Location] Load Cities Success';

export const loadCities = createAction(LOAD_CITIES);
export const loadCitiesSuccess = createAction(LOAD_CITIES_SUCCESS, props<{ cities: CityModel[] }>());
